import { Fragment } from "react";
import { CompletedAppointmentsResponse, ProviderCharge } from "../../api/types";
import { SimpleChargeSheet } from "./SimpleChargeSheet";
import { SaveAction } from "./types/chargeSheet";

interface Props {
  saveAction: ({
    patientId,
    appointmentId,
    status,
    modeOfEncounter,
    locationOfEncounter,
    dateOfEncounter,
  }: SaveAction) => void;
  sendToBillingAction: ({
    patientId,
    appointmentId,
    status,
    modeOfEncounter,
    locationOfEncounter,
    dateOfEncounter,
  }: SaveAction) => void;
  patientData?: any;
  chargeSheetData: ProviderCharge;
  isSendingToBilling: boolean;
  isSavingDraft: boolean;
  isFromNewBilling?: boolean;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  completedAppointments?:CompletedAppointmentsResponse;
  isLoading?: boolean;
  isLastError?: boolean;
  lastError?:any
  isPatientError?:boolean;
  // fetchedPatientData?:any;
  patientError?:any
  isLoadingPatient?:boolean;

}

export const SimpleChargeSheetModal = ({
  saveAction,
  chargeSheetData,
  sendToBillingAction,
  isSendingToBilling,
  isSavingDraft,
  isFromNewBilling,
  open,
  setOpen,
  completedAppointments,
  isLoading,
  isLastError,
  lastError,
  isPatientError,
  patientError,
  isLoadingPatient,
  patientData

}: Props) => (
  <Fragment>
    {open && (
      <SimpleChargeSheet
        open={open}
        setOpen={setOpen}
        isSendingToBilling={isSendingToBilling}
        isSavingDraft={isSavingDraft}
        saveAction={saveAction}
        chargeSheetData={chargeSheetData}
        sendToBillingAction={sendToBillingAction}
        isFromNewBilling={isFromNewBilling}
        completedAppointments={completedAppointments}
        isLoading={isLoading}
        lastError={lastError}
        isLastError={isLastError}
        isPatientError={isPatientError}
        patientError={patientError}
        isLoadingPatient={isLoadingPatient}
        patientData={patientData}

      />
    )}
  </Fragment>
)